<div class="text-center">
  <svg
    width="395"
    height="242"
    viewBox="0 0 395 242"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-automation-id="record-source-diagram"
  >
    <g clip-path="url(#clip0_3178_10458)">
      <mask
        id="mask0_3178_10458"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="-72"
        y="-74"
        width="382"
        height="382"
      >
        <rect x="-72" y="133.889" width="294" height="3" transform="rotate(-45 -72 133.889)" fill="#006D89" />
        <rect x="-64.2219" y="141.668" width="294" height="3" transform="rotate(-45 -64.2219 141.668)" fill="#006D89" />
        <rect x="-56.4436" y="149.446" width="294" height="3" transform="rotate(-45 -56.4436 149.446)" fill="#006D89" />
        <rect x="-48.6655" y="157.224" width="294" height="3" transform="rotate(-45 -48.6655 157.224)" fill="#006D89" />
        <rect x="-40.8872" y="165.002" width="294" height="3" transform="rotate(-45 -40.8872 165.002)" fill="#006D89" />
        <rect x="-33.1091" y="172.78" width="294" height="3" transform="rotate(-45 -33.1091 172.78)" fill="#006D89" />
        <rect x="-25.3311" y="180.558" width="294" height="3" transform="rotate(-45 -25.3311 180.558)" fill="#006D89" />
        <rect x="-17.5527" y="188.337" width="294" height="3" transform="rotate(-45 -17.5527 188.337)" fill="#006D89" />
        <rect x="-9.77466" y="196.115" width="294" height="3" transform="rotate(-45 -9.77466 196.115)" fill="#006D89" />
        <rect x="-1.99634" y="203.893" width="294" height="3" transform="rotate(-45 -1.99634 203.893)" fill="#006D89" />
        <rect x="5.78174" y="211.671" width="294" height="3" transform="rotate(-45 5.78174 211.671)" fill="#006D89" />
        <rect x="13.5598" y="219.449" width="294" height="3" transform="rotate(-45 13.5598 219.449)" fill="#006D89" />
        <rect x="21.3381" y="227.227" width="294" height="3" transform="rotate(-45 21.3381 227.227)" fill="#006D89" />
        <rect x="29.1162" y="235.006" width="294" height="3" transform="rotate(-45 29.1162 235.006)" fill="#006D89" />
        <rect x="36.8945" y="242.784" width="294" height="3" transform="rotate(-45 36.8945 242.784)" fill="#006D89" />
        <rect x="44.6726" y="250.562" width="294" height="3" transform="rotate(-45 44.6726 250.562)" fill="#006D89" />
        <rect x="52.4507" y="258.34" width="294" height="3" transform="rotate(-45 52.4507 258.34)" fill="#006D89" />
        <rect x="60.229" y="266.118" width="294" height="3" transform="rotate(-45 60.229 266.118)" fill="#006D89" />
        <rect x="68.0071" y="273.897" width="294" height="3" transform="rotate(-45 68.0071 273.897)" fill="#006D89" />
        <rect x="75.7854" y="281.675" width="294" height="3" transform="rotate(-45 75.7854 281.675)" fill="#006D89" />
        <rect x="83.5635" y="289.453" width="294" height="3" transform="rotate(-45 83.5635 289.453)" fill="#006D89" />
        <rect x="91.3416" y="297.231" width="294" height="3" transform="rotate(-45 91.3416 297.231)" fill="#006D89" />
        <rect x="99.1199" y="305.009" width="294" height="3" transform="rotate(-45 99.1199 305.009)" fill="#006D89" />
      </mask>
      <g mask="url(#mask0_3178_10458)">
        <circle cx="123.5" cy="121.5" r="120.5" fill="#006D89" />
      </g>
      <circle cx="274.5" cy="120.5" r="120.5" fill="#E9B350" />
      <mask
        id="mask1_3178_10458"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="8"
        y="-60"
        width="382"
        height="382"
      >
        <rect x="8" y="147.889" width="294" height="3" transform="rotate(-45 8 147.889)" fill="#006D89" />
        <rect x="15.7781" y="155.668" width="294" height="3" transform="rotate(-45 15.7781 155.668)" fill="#006D89" />
        <rect x="23.5564" y="163.446" width="294" height="3" transform="rotate(-45 23.5564 163.446)" fill="#006D89" />
        <rect x="31.3345" y="171.224" width="294" height="3" transform="rotate(-45 31.3345 171.224)" fill="#006D89" />
        <rect x="39.1128" y="179.002" width="294" height="3" transform="rotate(-45 39.1128 179.002)" fill="#006D89" />
        <rect x="46.8909" y="186.78" width="294" height="3" transform="rotate(-45 46.8909 186.78)" fill="#006D89" />
        <rect x="54.6689" y="194.558" width="294" height="3" transform="rotate(-45 54.6689 194.558)" fill="#006D89" />
        <rect x="62.4473" y="202.337" width="294" height="3" transform="rotate(-45 62.4473 202.337)" fill="#006D89" />
        <rect x="70.2253" y="210.115" width="294" height="3" transform="rotate(-45 70.2253 210.115)" fill="#006D89" />
        <rect x="78.0037" y="217.893" width="294" height="3" transform="rotate(-45 78.0037 217.893)" fill="#006D89" />
        <rect x="85.7817" y="225.671" width="294" height="3" transform="rotate(-45 85.7817 225.671)" fill="#006D89" />
        <rect x="93.5598" y="233.449" width="294" height="3" transform="rotate(-45 93.5598 233.449)" fill="#006D89" />
        <rect x="101.338" y="241.227" width="294" height="3" transform="rotate(-45 101.338 241.227)" fill="#006D89" />
        <rect x="109.116" y="249.006" width="294" height="3" transform="rotate(-45 109.116 249.006)" fill="#006D89" />
        <rect x="116.895" y="256.784" width="294" height="3" transform="rotate(-45 116.895 256.784)" fill="#006D89" />
        <rect x="124.673" y="264.562" width="294" height="3" transform="rotate(-45 124.673 264.562)" fill="#006D89" />
        <rect x="132.451" y="272.34" width="294" height="3" transform="rotate(-45 132.451 272.34)" fill="#006D89" />
        <rect x="140.229" y="280.118" width="294" height="3" transform="rotate(-45 140.229 280.118)" fill="#006D89" />
        <rect x="148.007" y="287.897" width="294" height="3" transform="rotate(-45 148.007 287.897)" fill="#006D89" />
        <rect x="155.785" y="295.675" width="294" height="3" transform="rotate(-45 155.785 295.675)" fill="#006D89" />
        <rect x="163.563" y="303.453" width="294" height="3" transform="rotate(-45 163.563 303.453)" fill="#006D89" />
        <rect x="171.342" y="311.231" width="294" height="3" transform="rotate(-45 171.342 311.231)" fill="#006D89" />
        <rect x="179.12" y="319.009" width="294" height="3" transform="rotate(-45 179.12 319.009)" fill="#006D89" />
      </mask>
      <g mask="url(#mask1_3178_10458)">
        <path
          d="M157.094 119C157.094 58 202.687 28 202.687 28C202.687 28 244.687 58 247.187 119C249.687 180 202.687 215.5 202.687 215.5C202.687 215.5 157.094 180 157.094 119Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3178_10458">
        <rect width="395" height="242" fill="white" />
      </clipPath>
    </defs>
  </svg>
</div>

<div class="d-flex flex-row px-6 pb-6 mt-8 justify-between">
  <div class="d-flex flex-column me-6 col">
    <div class="d-flex flex-row align-items-center mb-1" data-automation-id="snp-info-title">
      <div class="me-1">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="10" cy="10" r="10" fill="#006D89" />
        </svg>
      </div>

      <p class="text-primary-600 heading-30">{{ context.snpResearch }}</p>
    </div>
    <div data-automation-id="snp-info-body">
      {{ context.snpResearchExplanation }}
    </div>
  </div>

  <div class="d-flex flex-column me-6 col">
    <div class="d-flex flex-row align-items-center mb-1" data-automation-id="snpCrm-info-title">
      <div class="me-1">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_3181_10517)">
            <circle cx="10" cy="10" r="10" fill="#E9B350" />
            <mask
              id="mask0_3181_10517"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="-10"
              y="-10"
              width="46"
              height="46"
            >
              <rect x="-10" y="11.9447" width="31.0345" height="2" transform="rotate(-45 -10 11.9447)" fill="#F5F5F5" />
              <rect
                x="-5.75732"
                y="16.1874"
                width="31.0345"
                height="2"
                transform="rotate(-45 -5.75732 16.1874)"
                fill="#F5F5F5"
              />
              <rect
                x="-1.51465"
                y="20.4299"
                width="31.0345"
                height="2"
                transform="rotate(-45 -1.51465 20.4299)"
                fill="#F5F5F5"
              />
              <rect
                x="2.72803"
                y="24.6726"
                width="31.0345"
                height="2"
                transform="rotate(-45 2.72803 24.6726)"
                fill="#F5F5F5"
              />
            </mask>
            <g mask="url(#mask0_3181_10517)">
              <circle cx="10" cy="10" r="10" fill="#F8F8F8" />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_3181_10517">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>

      <p class="text-primary-600 heading-30">{{ context.snpCrm }}</p>
    </div>
    <div data-automation-id="snpCrm-info-body">
      {{ context.snpCrmExplanation }}
    </div>
  </div>

  <div class="d-flex flex-column col">
    <div class="d-flex flex-row align-items-center mb-1" data-automation-id="crm-info-title">
      <div class="me-1">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="10" cy="10" r="10" fill="#E9B350" />
        </svg>
      </div>

      <p class="text-primary-600 heading-30">{{ context.crm }}</p>
    </div>
    <div data-automation-id="crm-info-body">
      {{ context.crmExplanation }}
    </div>
  </div>
</div>
